import mardi from './images/Mardi Grad Project.png';
import mzian from './images/Mzian Project.png';
import portfolio from './images/My Portfolio.png';
import ecommerce from './images/Ecommerce shop.png'
export const products = [
  {
    id: 1,
    img: mardi,
    link: "https://mardigras.ilanedri.com/",
    
  },
  {
    id: 2,
    img: mzian,
    link: "http://mzian.co.il",
  },
  {
    id: 3,
    img: portfolio,
    link: "http://ilanedri.com",
  },
  {
    id: 4,
    img: ecommerce,
    link: "https://e-commerce-shop-611u.onrender.com",
  },
  {
    id: 5,
    img: "",
    link: "http://lama.dev",
  },
  {
    id: 6,
    img: "",
    link: "http://lama.dev",
  },
];
